import { render, staticRenderFns } from "./RowSupportMenu.vue?vue&type=template&id=b8c2ecf8"
import script from "./RowSupportMenu.vue?vue&type=script&lang=js"
export * from "./RowSupportMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8c2ecf8')) {
      api.createRecord('b8c2ecf8', component.options)
    } else {
      api.reload('b8c2ecf8', component.options)
    }
    module.hot.accept("./RowSupportMenu.vue?vue&type=template&id=b8c2ecf8", function () {
      api.rerender('b8c2ecf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/flowControl/RowSupportMenu.vue"
export default component.exports